<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >


        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.state"
                  placeholder="一级分类"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.velue"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >
      新增
    </el-button>
    <el-button
      v-if="multipleSelection.length>0"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      @click="batchDel"
    >
      删除
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
              label="商家一级分类"
      >
        <template slot-scope="scope">
          {{scope.row.business_name}}
        </template>
      </el-table-column>
      <el-table-column
        label="平台返佣"
      >
        <template slot-scope="scope">
          {{scope.row.platform_scale}}
        </template>
      </el-table-column>
      <el-table-column
              label="一级代理返佣"
      >
        <template slot-scope="scope">
          {{scope.row.one_agent_scale}}
        </template>
      </el-table-column>
      <el-table-column
              label="二级代理返佣"
      >
        <template slot-scope="scope">
          {{scope.row.two_agent_scale}}
        </template>
      </el-table-column>
      <el-table-column
              label="三级代理返佣"
      >
        <template slot-scope="scope">
          {{scope.row.three_agent_scale}}
        </template>
      </el-table-column>
      <el-table-column
              label="消费商家返佣"
      >
        <template slot-scope="scope">
          {{scope.row.user_recom_scale}}
        </template>
      </el-table-column>
      <el-table-column
              label="消费者返佣"
      >
        <template slot-scope="scope">
          {{scope.row.consume_agent_scale}}
        </template>
      </el-table-column>
      <el-table-column
              label="推荐人返佣"
      >
        <template slot-scope="scope">
          {{scope.row.shop_locking}}
        </template>
      </el-table-column>
      <el-table-column
              label="分享返佣"
      >
        <template slot-scope="scope">
          {{scope.row.sharers_scale}}
        </template>
      </el-table-column>
      <el-table-column
              label="引流券商家返佣"
      >
        <template slot-scope="scope">
          {{scope.row.drainage_coupon_scale}}
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="220"
      >
        <template slot-scope="scope">
          <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="openEditForm(scope.row)"
          >编辑</el-button>





          <el-button
            type="primary"
            plain
            size="mini"
            @click="del(scope.row.id)"
          >删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneclass="oneclass"
      v-model="editFormVisible"
      @submit="getTableData"
    />



  </d2-container>
</template>
<script>
import * as oneclassService from "@/api/sys/oneclass";
import * as agentService from "@/api/sys/agent";
import editForm from "./editForm";
import util from '@/libs/util.js'
export default {
  name: "SmallposterPage",
  components: { editForm },
  data() {
    return {
      searchForm: {
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
        typeOptions: [
            {
                value: "0",
                label: "正常"
            },
            {
                value: "1",
                label: "禁用"
            }
        ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneclass: {},
        clicksFormVisible:false,
        exposureFormVisible: false,
      editFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid: util.cookies.get('agentid'),
          xt_id: util.cookies.get('xt_id'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.disCouponPagedList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
      getImgUrl(row){
          return "https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/"+row.advImg;
      },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(oneclass) {
      this.oneclass = oneclass;
      this.editFormVisible = true;
    },
      openExposureForm(oneclass) {
          this.oneclass = oneclass;
          this.exposureFormVisible = true;
      },
      openClicksForm(oneclass) {
          this.oneclass = oneclass;
          this.clicksFormVisible = true;
      },

    add() {
      this.oneclass = {};
      this.editFormVisible = true;
    },
    batchDel() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          agentService.batchCouponRakeback({
            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
          })
          .then(() => {
            this.getTableData();
          });
      });
    },


    del(id) {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          agentService.delCouponRakeback({id:id}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
